import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANTS } from "../constants/routeConstants";
import { DataContext } from "../dataContext";
import { ReactComponent as ChevronRight } from "../assets/ico_chevron_right.svg";
import { THEME_OPTIONS, useThemePreference } from "../theme/appearance";

const { SET_DEFAULT_ACCOUNT } = ROUTE_CONSTANTS;

const Settings = () => {
  const { defaultAccounts, defaultAccountsLoading, cards, identifiers } =
    useContext(DataContext);
  const navigate = useNavigate();
  const [theme, setTheme] = useThemePreference();

  const identifierTypes = [
    ...new Set(
      identifiers
        .sort((a, b) => a.type.localeCompare(b.type))
        .map(({ type }) => type)
    ),
  ];

  return (
    <main className="page_with_nav" style={{ justifyContent: "flex-start" }}>
      {identifiers.length && defaultAccounts.length ? (
        <div>
          {identifierTypes.map((identifierType) => {
            return (
              <div
                key={identifierType}
                style={
                  identifierType === identifierTypes[0]
                    ? { marginTop: "10px" }
                    : { marginTop: "30px" }
                }
              >
                <div className="np-group-header">
                  Default card for {identifierType}
                </div>
                {identifiers
                  .filter(({ type }) => type === identifierType)
                  .map((identifier) => {
                    let defaultCardForIdentifier = undefined;
                    defaultAccounts.find((accounts) => {
                      defaultCardForIdentifier = accounts[1].find(
                        ({ value }) => value === identifier.value
                      );
                      return defaultCardForIdentifier;
                    });
                    return (
                      <div
                        key={identifier.value}
                        className="status"
                        style={{
                          marginTop: "10px",
                          alignItems: "center",
                        }}
                        onClick={() =>
                          navigate(
                            SET_DEFAULT_ACCOUNT.replace(":id", identifier.value)
                          )
                        }
                      >
                        <div className="np-list-body">
                          <div className="np-list-title">{identifier.value}</div>
                          <div className="np-list-sub">
                            {defaultCardForIdentifier ? (
                              <>
                                {cards.find(
                                  (card) =>
                                    defaultCardForIdentifier.default_card ===
                                    card.uuid
                                )?.last_four ? (
                                  <>
                                    {/* 1st choice is show the card last_four */}
                                    Card Ending{" "}
                                    {
                                      cards.find(
                                        (card) =>
                                          defaultCardForIdentifier.default_card ===
                                          card.uuid
                                      )?.last_four
                                    }
                                  </>
                                ) : (
                                  <>
                                    {/* 2nd choice is show the account name */}
                                    {
                                      defaultAccounts.find((arr) =>
                                        arr[1].find(
                                          ({ value }) =>
                                            value === identifier.value
                                        )
                                      )[0].name
                                    }
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {/* Final choice is show this if there's no account or card */}
                                Another account and/or institution
                              </>
                            )}
                          </div>
                        </div>
                        <ChevronRight className="stroke_sending_text_primary" />
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div>
      ) : (
        <h3 className="center_page_with_nav">
          {defaultAccountsLoading ? (
            <>Account and settings data is loading.</>
          ) : (
            <>Something went wrong while fetching account and settings data.</>
          )}
        </h3>
      )}

      {/* Appearance is a device preference (localStorage), not an FI or
          account setting, so it renders regardless of the account data above. */}
      <section style={{ marginTop: "30px" }} aria-labelledby="appearance_label">
        <div className="np-group-header" id="appearance_label">
          Appearance
        </div>
        <div
          className="np-segmented"
          role="radiogroup"
          aria-labelledby="appearance_label"
          style={{ marginTop: "10px" }}
          data-cy="appearance_selector"
        >
          {THEME_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={theme === option.value}
              onClick={() => setTheme(option.value)}
              data-cy={`appearance_${option.value}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Settings;
